export const ROLE_DESC = {
  OWNER: "Akses penuh: HPP, margin, override harga, payroll, pengaturan, backup, integrasi.",
  MANAGEMENT: "Kelola operasional, stok, pembelian, keuangan, payroll. Tanpa pengaturan sistem.",
  ADMIN: "Data master, WO, pembelian, laporan, audit. Tanpa pembayaran & HPP.",
  KASIR: "Pelanggan, WO, invoice, pembayaran, struk. Diskon maks sesuai batas.",
  GUDANG: "Scan & keluarkan part, terima PO, opname, retur. Tanpa harga beli.",
  MEKANIK: "WO yang ditugaskan, progres, permintaan part, komisi sendiri. Tanpa HPP.",
};
